import { ErrorType } from '../types/index.js';
import { ConcreteException } from '../base.js';
export class Web3Exception extends ConcreteException {
    static errorClass = 'Web3Exception';
    constructor(error, context) {
        super(error, context);
        this.type = ErrorType.Web3;
    }
    parse() {
        this.setName(Web3Exception.errorClass);
    }
}
